import { render, staticRenderFns } from "./searchArtist.vue?vue&type=template&id=b95c0c5c&scoped=true&"
import script from "./searchArtist.vue?vue&type=script&lang=ts&"
export * from "./searchArtist.vue?vue&type=script&lang=ts&"
import style0 from "./searchArtist.vue?vue&type=style&index=0&id=b95c0c5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95c0c5c",
  null
  
)

export default component.exports